export default {
  user: "user", // 移动端和 wps 端
  exam: "exam", // 测评
  device: "device", // 设备端，包括：学生主机、教师主机、信息机、减压亭等
  authorization: "authorization", //  pc端授权功能
};
